/* global Vue */
//import Vue from 'vue'
import App from './App.vue';

window.requirecss('/app/respond/vacancy/quick/style.css?v=' + window.APPVER);

new Vue({ el: '#respond', render: h=>h(App) });

//EOF//